import React, { useEffect, useState } from 'react'

import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts'
import ContentLoader from "react-content-loader";

export default function TopicsMandatoryPieChart(props) {
    const [ chartData, setChartData ] = useState(null);

    let renderLabel = function(entry) {
        return `${entry.name}: ${entry.value}`;
    }

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="rechart-custom-tooltip">
                    <b>{payload[0].name}</b>
                    <p className="m-0">{payload[0].value} von {props.data.topics.length} entspricht<br/>einem Anteil von {((payload[0].value / props.data.topics.length) * 100).toFixed(0)}%</p>
                </div>
            );
        }
      
        return null;
    };

    useEffect(() => {
        if (props.data) {
            let mandatoryTopics = props.data.topics.filter(x => x.mandatory === true).length;
            let optionalTopics = props.data.topics.filter(x => x.mandatory === false).length;

            setChartData([{
                name: 'Pflicht',
                value: mandatoryTopics,
                color: '#ffc107'
            }, {
                name: 'Optional',
                value: optionalTopics,
                color: '#6c757d'
            }]);
        }
    }, [props.data]);

    return (
        <>
        {
            chartData != null && chartData !== undefined ?
            <>
                <b className="d-block text-center">Obligatorisch relevante Themen</b>
                <PieChart width={300} height={300} className="d-block mx-auto">
                    <Pie data={chartData} dataKey="value" cx="50%" cy="50%" outerRadius={70} fill="#17a2b8" label={renderLabel} >
                        {
                            chartData.map((entry, index) => {
                                return <Cell 
                                    key={`cell-${index}`}
                                    fill={entry.color}
                                    strokeWidth={0} />
                            })
                        }
                    </Pie>

                    <Legend />
                    <Tooltip content={<CustomTooltip />} />
                </PieChart>
            </>
            :
            <DummyPieChart />
        }
            
        </>
    )
}

const DummyPieChart = (props) => {
	return (
		<ContentLoader
			viewBox="0 0 400 200"
			height={200}
			width={400}
			style={{maxWidth: "100%"}}
			{...props}>
			<rect x="100" y="5" rx="0" ry="0" width="200" height="15" />
			<circle cx="140" cy="110" r="70" />
			<rect x="230" y="50" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="50" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="64" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="64" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="78" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="78" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="92" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="92" rx="0" ry="0" width="30" height="7" />
		</ContentLoader>
	);
};